import { StaffActivitiesByDescription } from "../../types";

export const staffActivities: StaffActivitiesByDescription = {
  "New Hampshire Tier2 Submit": {
    parameters: {
      linkUrls: ["https://nh.tieriiportal.aristatek.com/"],
      staffInputs: {
        documentTypes: {
          submission: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Tier2 Submit",
    state: "NH",
  },
};
